module.exports = __webpack_public_path__ + "img/blogs_navy_blue.f2463045.png";